import {TransportIteraction} from './transport-iteraction';

export class Transport {
  transfers: TransportIteraction[];
}



// WEBPACK FOOTER //
// ./src/app/shared/api/model/transport.ts